<template>
<b-modal ref="modal" visible size="lg" :hide-footer="true" title="Postzegel post" @hidden="$emit('close')">
      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Weeg de bestelling en selecteer het gewicht van de bestelling <br> LET OP: Klikken is betalen! </h3>
        </div>
        <div class="block-content">
          <div class="row gutters-tiny">
            <div class="col-md-4">
              <postage-stamp-type icon="envelope"  @click="createShipment(null)">
                Ongefrankeerd
              </postage-stamp-type>
            </div>

            <div class="col-md-4">
              <postage-stamp-type icon="envelope" @click="createShipment(10)">
                0-20 gram
              </postage-stamp-type>
            </div>

            <div class="col-md-4">
              <postage-stamp-type icon="envelope" @click="createShipment(40)">
                20-50 gram
              </postage-stamp-type>
            </div>

            <div class="col-md-4">
              <postage-stamp-type icon="envelope"  @click="createShipment(75)">
                50-100 gram
              </postage-stamp-type>
            </div>
          </div>
        </div>
      </div>
</b-modal>
</template>

<script>
import PostageStampType from './PostageStampType'

export default {
  components: {
    PostageStampType
  },
  props: {
    order: Object,
    shipment: Object
  },
  data () {
    return {
      postageStampType: null
    }
  },
  methods: {
    createShipment (weight) {
      const data = {
        ...this.shipment,
        order_number: this.order.number,
        weight: weight
      }

      this.$api.createShipment(data)
        .then((result) => this.$api.printLabel(result.data.data.id))
        .then(() => {
          this.$refs.modal.hide()
        })
        .catch(() => {
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het printen van het verzendeticket. Probeer het opnieuw.`, 'error')
        })
    }
  }
}
</script>





// WEBPACK FOOTER //
// PostageStampDetailModal.vue?7744ba06